import { globalTypes } from "reducers/types/global";
// Action types
export const types = {
    PUSH_NOTIFICATIONS_LIST_DEVICES: "pushNotifications/PUSH_NOTIFICATIONS_LIST_DEVICES",
    PUSH_NOTIFICATIONS_LIST_DEVICES_SUCCESS: "pushNotifications/PUSH_NOTIFICATIONS_LIST_DEVICES_SUCCESS",
    PUSH_NOTIFICATIONS_DELETE_DEVICE: "pushNotifications/PUSH_NOTIFICATIONS_DELETE_DEVICE",
    PUSH_NOTIFICATIONS_DELETE_DEVICE_PRE: "pushNotifications/PUSH_NOTIFICATIONS_DELETE_DEVICE_PRE",
    PUSH_NOTIFICATIONS_REGISTER_DEVICE: "pushNotifications/PUSH_NOTIFICATIONS_REGISTER_DEVICE",
    LIST_ALL_USER_DEVICES: "pushNotifications/LIST_ALL_USER_DEVICES",
    PUSH_NOTIFICATION_HIDE_WIDGET: "pushNotifications/ PUSH_NOTIFICATION_HIDE_WIDGET",
    PUSH_NOTIFICATION_IS_ENABLED: "pushNotifications/PUSH_NOTIFICATION_IS_ENABLED",
    PUSH_NOTIFICATION_IS_DEVICE_CONFIGURED: "pushNotifications/PUSH_NOTIFICATION_IS_DEVICE_CONFIGURED",
    LIST_USER_DEVICES_CONFIGURED: "pushNotifications/LIST_USER_DEVICES_CONFIGURED",
    SET_LIST_USER_DEVICES_CONFIGURED: "pushNotifications/SET_LIST_USER_DEVICES_CONFIGURED",
    CHECK_CONFIGURATION: "pushNotifications/CHECK_CONFIGURATION",
    CHECK_CONFIGURATION_SUCCESS: "pushNotifications/CHECK_CONFIGURATION_SUCCESS",
    ASK_PERMISIONS: "pushNotifications/ASK_PERMISIONS",
    SET_BIOMETRY_CANCELLED: "pushNotifications/SET_BIOMETRY_CANCELLED",
    CLEAN: "pushNotifications/CLEAN",
    LINK_DEVICE: "pushNotifications/LINK_DEVICE",
    SET_FETCHING: "pushNotifications/SET_FETCHING",
    SET_FETCHING_ACTION: "pushNotifications/SET_FETCHING_ACTION",
    PUSH_NOTIFICATION_SET_SHOW_AGAIN: "settingsPersisted/PUSH_NOTIFICATION_SET_SHOW_AGAIN",
    PUSH_NOTIFICATION_REFRESH_TOKEN: "pushNotifications/PUSH_NOTIFICATION_REFRESH_TOKEN",
};

// Initial state
export const INITIAL_STATE = {
    fetching: false,
    fetchingAction: false,
    pushNotificationsConfiguredUserDevices: null,
    device: null,
    enabled: undefined,
    isDeviceConfigured: undefined,
    configuredDevices: [],
    fetchingConfiguration: null,
    biometryCancelled: null,
    hidden: null,
    isMobileNative: null,
    showAgain: true,
    registrationId: null,
};

// Reducer
export default (state = INITIAL_STATE, action = {}) => {
    const {
        enabled,
        isDeviceConfigured,
        configuredDevices,
        biometryCancelled,
        fetching,
        hidden,
        isMobileNative,
        fetchingAction,
        registrationId,
    } = action;
    switch (action.type) {
        case types.PUSH_NOTIFICATIONS_LIST_DEVICES:
            return { ...state, fetching: true };
        case types.PUSH_NOTIFICATIONS_LIST_DEVICES_SUCCESS:
            return { ...state, fetching: false, pushNotificationsConfiguredUserDevices: action.listUserDevices };
        case types.PUSH_NOTIFICATIONS_DELETE_DEVICE_PRE:
            return { ...state, device: action.device };
        case types.PUSH_NOTIFICATIONS_DELETE_DEVICE:
            return { ...state, device: action.device, fetching: true };
        case types.PUSH_NOTIFICATION_IS_ENABLED:
            return { ...state, fetching: true };
        case types.PUSH_NOTIFICATION_HIDE_WIDGET:
            return { ...state, hidden };
        case types.PUSH_NOTIFICATION_IS_DEVICE_CONFIGURED:
            return { ...state, fetching: true };
        case types.LIST_USER_DEVICES_CONFIGURED:
            return { ...state, fetching: true, isMobileNative };
        case types.SET_LIST_USER_DEVICES_CONFIGURED:
            return { ...state, configuredDevices };
        case types.CHECK_CONFIGURATION:
            return { ...state, fetchingConfiguration: true };
        case types.CHECK_CONFIGURATION_SUCCESS:
            return { ...state, fetchingConfiguration: false, enabled, isDeviceConfigured };
        case types.ASK_PERMISIONS:
            return { ...state };
        case types.SET_BIOMETRY_CANCELLED:
            return { ...state, biometryCancelled };
        case types.LINK_DEVICE:
            return { ...state, registrationId };
        case types.PUSH_NOTIFICATIONS_REGISTER_DEVICE:
            return { ...state, fetchingAction: true };
        case types.SET_FETCHING:
            return { ...state, fetching };
        case types.SET_FETCHING_ACTION:
            return { ...state, fetchingAction };
        case types.PUSH_NOTIFICATION_REFRESH_TOKEN:
            return { ...state, registrationId };
        case types.PUSH_NOTIFICATION_SET_SHOW_AGAIN:
            return {
                ...state,
                showAgain: action.showAgain,
            };
        case types.CLEAN:
            return { ...INITIAL_STATE, showAgain: state.showAgain };
        case globalTypes.CLEAN_UP:
            return { ...INITIAL_STATE, showAgain: state.showAgain };

        default:
            return state;
    }
};

// Action creators
export const actions = {
    pushNotificationsListUserDevices: () => ({
        type: types.PUSH_NOTIFICATIONS_LIST_DEVICES,
    }),
    pushNotificationsDeleteUserDevice: (idDevice) => ({
        type: types.PUSH_NOTIFICATIONS_DELETE_DEVICE,
        idDevice,
    }),
    pushNotificationsDeleteUserDevicePre: (device) => ({
        type: types.PUSH_NOTIFICATIONS_DELETE_DEVICE_PRE,
        device,
    }),
    pushNotificationsRegisterUserDevice: () => ({
        type: types.PUSH_NOTIFICATIONS_REGISTER_DEVICE,
    }),
    listAllUserDevices: () => ({
        type: types.LIST_ALL_USER_DEVICES,
    }),
    askPermissions: () => ({
        type: types.ASK_PERMISIONS,
    }),

    setHideWidget: (hidden) => ({
        type: types.PUSH_NOTIFICATION_HIDE_WIDGET,
        hidden,
    }),
    listUserDevicesConfigured: (isMobileNative) => ({
        type: types.LIST_USER_DEVICES_CONFIGURED,
        isMobileNative,
    }),
    checkConfiguration: () => ({
        type: types.CHECK_CONFIGURATION,
    }),
    setBiometryCancelled: (biometryCancelled) => ({
        type: types.SET_BIOMETRY_CANCELLED,
        biometryCancelled,
    }),
    setPushNotificationShowAgain: (showAgain) => ({
        type: types.PUSH_NOTIFICATION_SET_SHOW_AGAIN,
        showAgain,
    }),
    refreshToken: (registrationId) => ({
        type: types.PUSH_NOTIFICATION_REFRESH_TOKEN,
        registrationId,
    }),
    linkDevice: (registrationId) => ({
        type: types.LINK_DEVICE,
        registrationId,
    }),
};

// Selectors
export const selectors = {
    getFetching: (state) => state.pushNotifications.fetching,
    getFetchingAction: (state) => state.pushNotifications.fetchingAction,
    isFetching: (state) => state.pushNotifications.fetchingConfiguration,
    getPushNotificationsConfiguredUserDevices: (state) =>
        state.pushNotifications.pushNotificationsConfiguredUserDevices,
    getDevice: (state) => state.pushNotifications.device,
    isShowAgain: (state) => state.pushNotifications.showAgain,
    isEnabled: (state) => state.pushNotifications.enabled,
    isConfigured: (state) => state.pushNotifications.isDeviceConfigured,
    configuredDevices: (state) => state.pushNotifications.configuredDevices,
    biometryCancelled: (state) => state.pushNotifications.biometryCancelled,
    isHidden: (state) => state.pushNotifications.hidden,
};
